import { render } from "./ExportFacture.vue?vue&type=template&id=b4b971ca&scoped=true"
import script from "./ExportFacture.vue?vue&type=script&lang=js"
export * from "./ExportFacture.vue?vue&type=script&lang=js"

import "./ExportFacture.vue?vue&type=style&index=0&id=b4b971ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b971ca"]])

export default __exports__